import { render, staticRenderFns } from "./msTrV3.vue?vue&type=template&id=6d162bdc&scoped=true"
import script from "./msTrV3.vue?vue&type=script&lang=js"
export * from "./msTrV3.vue?vue&type=script&lang=js"
import style0 from "./msTrV3.vue?vue&type=style&index=0&id=6d162bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d162bdc",
  null
  
)

export default component.exports